import { render } from "./FolderData.vue?vue&type=template&id=0daa4c3c&scoped=true"
import script from "./FolderData.vue?vue&type=script&lang=js"
export * from "./FolderData.vue?vue&type=script&lang=js"

import "./FolderData.vue?vue&type=style&index=0&id=0daa4c3c&lang=sass&scoped=true"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0daa4c3c"]])

export default __exports__